import { BaseService } from "./base.service";
import { api } from "../client/axiosClient";
import { CustomResponseEntity } from "../types/common";
import {
  SyncConfigDto,
  CreateSyncConfigDto,
  UpdateSyncConfigDto,
  SyncSourceOptionsDto,
  BackfillRequestDto,
  BackfillResultDto,
  SyncQueueDto,
  SyncRunDto,
} from "../types/dtos/sync";

const BASE_PATH = "/api/v1/sync-configs";

export class SyncConfigService extends BaseService<
  SyncConfigDto,
  CreateSyncConfigDto,
  UpdateSyncConfigDto
> {
  constructor() {
    super(BASE_PATH);
  }

  findAll(): Promise<CustomResponseEntity<SyncConfigDto[]>> {
    return api.get(BASE_PATH);
  }

  getSourceOptions(): Promise<CustomResponseEntity<SyncSourceOptionsDto>> {
    return api.get(`${BASE_PATH}/source-options`);
  }

  findById(id: string): Promise<CustomResponseEntity<SyncConfigDto>> {
    return api.get(`${BASE_PATH}/${id}`);
  }

  create(data: CreateSyncConfigDto): Promise<CustomResponseEntity<SyncConfigDto>> {
    return api.post(BASE_PATH, data);
  }

  update(id: string, data: UpdateSyncConfigDto): Promise<CustomResponseEntity<SyncConfigDto>> {
    return api.put(`${BASE_PATH}/${id}`, data);
  }

  delete(id: string): Promise<CustomResponseEntity<void>> {
    return api.delete(`${BASE_PATH}/${id}`);
  }

  backfill(id: string, data: BackfillRequestDto): Promise<CustomResponseEntity<BackfillResultDto>> {
    return api.post(`${BASE_PATH}/${id}/backfill`, data);
  }

  getQueueItems(
    configId: string,
    page: number,
    size: number
  ): Promise<CustomResponseEntity<unknown>> {
    return api.get(`${BASE_PATH}/${configId}/queue`, {
      params: { page, size },
    });
  }

  getRuns(
    configId: string,
    page: number,
    size: number,
    excludeIdle: boolean
  ): Promise<CustomResponseEntity<unknown>> {
    return api.get(`${BASE_PATH}/${configId}/runs`, {
      params: { page, size, excludeIdle },
    });
  }

  requestRunReport(
    configId: string,
    runId: string
  ): Promise<CustomResponseEntity<SyncRunDto>> {
    return api.post(`${BASE_PATH}/${configId}/runs/${runId}/report`);
  }

  getRunReportDownloadUrl(
    configId: string,
    runId: string
  ): Promise<CustomResponseEntity<string>> {
    return api.get(`${BASE_PATH}/${configId}/runs/${runId}/report/download-url`);
  }
}

export const syncConfigService = new SyncConfigService();
